import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH = registerQuery({
  fieldName: 'getReenrollmentFiltersFromFilterBranch',
  args: ['isClassicWorkflow', 'enrollmentCriteria', 'existingReEnrollmentTriggerSets', 'existingAssociatedLists', 'existingFlowEventFilters'],
  fetcher(data) {
    return http.post('automationplatform/v1/re-enrollment-triggers/generate', {
      data
    });
  }
});